// src/hooks/useStripe.ts
import { useCallback, useState } from 'react';
import { supabase } from '@/lib/supabase/browserClient';

type CheckoutOptions = {
  priceId: string;
  mode?: 'subscription' | 'payment';
  successUrl?: string;
  cancelUrl?: string;
};

export function useStripe() {
  const [loading, setLoading] = useState(false);
  const [lastError, setLastError] = useState<null | string>(null);

  const checkout = useCallback(async (opts: CheckoutOptions) => {
    setLoading(true);
    setLastError(null);
    try {
      if (!supabase) throw new Error('Supabase not configured');

      const { data, error } = await supabase.functions.invoke('stripe-checkout', {
        body: {
          price_id: opts.priceId,
          mode: opts.mode ?? 'subscription',
          success_url: opts.successUrl ?? window.location.origin + '/billing/success',
          cancel_url: opts.cancelUrl ?? window.location.origin + '/billing/cancel',
        },
      });

      if (error) throw error;
      if (!data?.url) throw new Error('Checkout did not return a redirect URL');

      window.location.href = data.url as string;
    } catch (e: any) {
      console.error('[Mystara] checkout error', e);
      setLastError(e?.message ?? 'Checkout failed');
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { checkout, loading, lastError };
}
